import router from './router'
import store from './store'
import {getToken, setToken, removeToken} from '@/utils/auth' // 验权
import {myUtil} from '@/utils/util' // 工具

router.beforeEach((to, from, next) => {
    console.log("initb")
    //免登录页面，直接跳转
    if (to.path.indexOf("warn") >= 0 || to.path.indexOf("/activity") >= 0) {
        next();
        return
    }
    //微信支付页面，获取openid后直接跳转
    if (to.path.indexOf("/wxpay") >= 0) {
        if (to.fullPath.indexOf("openId=") >= 0) {
            next();
            return
        }
       // console.log(to.fullPath)
        //url编码
        let go = encodeURIComponent(to.fullPath)
       // console.log(store.getters.base_api + 'getOpenId?go=' + go)
        window.location.href = store.getters.base_api + 'getOpenId?go=' + go;
        next(false);
        return
    }
    //注入 环境信息
    if (store.getters.companyInfo === null) {
        store.dispatch('getHome').then(res => {
            homeAfterNext(to, next)
        }).catch(() => { //初始化失败
            next("/warn/01")
        })
        return
    }
    homeAfterNext(to, next)
})

router.afterEach((to, from) => {

})

function homeAfterNext(to, next) {
    //注入异步路由
    // if (!store.getters.asyncRouterEnd) {
    //     store.dispatch('GenerateRoutes', store.getters.userno).then(() => {
    //         router.addRoutes(store.getters.addRouters)
    //         next({...to})
    //     })
    //     return
    // }
    //建立回话
    if (to.query.jsessionid && to.path.indexOf("/login") >= 0) {
        store.dispatch('setToken', to.query.jsessionid)
        let decodeUrlGo = decodeURIComponent(to.query.go)
        next(decodeUrlGo)
        return
    }
    // 用户信息拉取
    if (getToken()) {
        if (store.getters.userInfo === null) {
            store.dispatch('getUserInfo').then(res => { // 拉取当前用户信息
                userInfoAfterNext(to, next)
            }).catch(() => { // 登录信息拉取失败
                store.dispatch('removeToken').then(
                    userInfoAfterNext(to, next)
                );
            });
            return
        }
    }
    userInfoAfterNext(to, next)
}

function userInfoAfterNext(to, next) {
    if (store.getters.userInfo === null && threePartyLoginIng(to.query.state ? to.query.state : 0, (to.path.indexOf("/login") > 0 && to.query.state == 0) ? to.query.go : to.fullPath)) {
        console.warn('threePartyLoginIng to.fullPath:' + to.fullPath)
        next(false)
        return
    }
    if (to.path.indexOf("/login") < 0 && store.getters.companyInfo && to.meta && to.meta.needLogin) {
        let needUserStatus = store.getters.companyInfo.needBindUser ? 1 : 0
        let userStatus = store.getters.userInfo ? store.getters.userInfo.status : -1
        if (needUserStatus > userStatus) {
            //next("/login?userno="+store.getters.userno+"&state="+needUserStatus+"&go="+to.path)
            //return
            store.dispatch('openPopupLogin', true)
            // lastNext(to,next)
            next(false)
            return
        } else if (to.path.indexOf("/bindPhone") < 0 && store.getters.userInfo && store.getters.userInfo.phone === null) {
            next("/bindPhone?go=" + to.path)
            return
        }
    }
    if (store.getters.popupLogin) {
        store.dispatch('openPopupLogin', false)
    }
    //设置标题
    const title = to.meta && to.meta.title
    if (title) {
        document.title = title
    }
    next()
}

export function threePartyLoginIng(state, go) {
    if (myUtil.isUserAgentWeChat() || myUtil.isUserAgentAllipay() || state == 'pc-test') {
        let reUrl = ''
        if (myUtil.isUserAgentWeChat()) {
            reUrl = store.getters.base_api + 'oauth2?go=' + go
        }
        if (myUtil.isUserAgentAllipay()) {
            reUrl = store.getters.base_api + 'oauth2Ali?go=' + go
        }
        if ('pc-test' == state) {
            reUrl = store.getters.base_api + 'oauth2?go=' + go
        }
        if (state) {
            reUrl += "&state=" + state
        }
        window.location.href = reUrl
    } else {
        return false
    }
    return true
}
